import { resetNotification } from '@store/notificationWindow/notificationWindow.action';
import { ConnectedProps, connect } from 'react-redux';

export const modalConnector = connect(null, {
  resetNotification,
});

export type ModalReduxProps = ConnectedProps<typeof modalConnector>;
